import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Globe, MessageCircle } from "lucide-react";
import { locations, cityLinks } from "../data/locationsData";
import ConciergeChat from "./ConciergeChat";

const services = [
  { name: "Tours & Packages", path: "/tours" },
  { name: "Airport Transfers", path: "/services/airport-transfers" },
  { name: "Minibus Charter", path: "/services/minibus-charter" },
  { name: "Cruise Terminal Transfers", path: "/services/cruise-terminal" },
  { name: "Corporate Travel", path: "/corporate-travel" },
  { name: "Wedding Transport", path: "/services/weddings" },
  { name: "Hens & Bucks Parties", path: "/services/hens-bucks" },
  { name: "Special Events", path: "/services/special-events" },
  { name: "Our Fleet", path: "/fleet" }
];

export const SeoFooter = () => (
  <>
  <ConciergeChat />
  <footer data-testid="seo-footer" className="bg-gray-950 text-white pt-14 pb-8">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-10">
        <div className="col-span-2 lg:col-span-1">
          <img src="/logo-dark.png" alt="Limo Near Me" className="h-12 w-auto mb-4" />
          <p className="text-gray-400 text-sm mb-4">
            Limo Near Me is a private chauffeur, airport transfer and minibus charter company
            servicing Brisbane, the Gold Coast, Sunshine Coast and major cities Australia-wide.
            Luxury vehicles for every group size — solo travellers to 200+ guest convoys — fixed prices, available 24/7.
          </p>
          <div className="space-y-2 text-sm text-gray-300">
            <a href="tel:+61481437772" className="flex items-center gap-2 hover:text-amber-400 transition-colors" data-testid="footer-phone">
              <Phone className="h-4 w-4 text-amber-400" /> +61 481 437 772
            </a>
            <a href="https://wa.me/61481437772" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-amber-400 transition-colors" data-testid="footer-whatsapp">
              <MessageCircle className="h-4 w-4 text-amber-400" /> WhatsApp us anytime
            </a>
            <a href="mailto:info@limonearme.com.au" className="flex items-center gap-2 hover:text-amber-400 transition-colors" data-testid="footer-email">
              <Mail className="h-4 w-4 text-amber-400" /> info@limonearme.com.au
            </a>
            <span className="flex items-center gap-2">
              <Globe className="h-4 w-4 text-amber-400" /> www.limonearme.com.au
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-amber-400">Services</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            {services.map((s) => (
              <li key={s.path}>
                <Link to={s.path} className="hover:text-white transition-colors">{s.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-4 text-amber-400">Cities</h4>
          <ul className="space-y-2 text-sm text-gray-400">
            {cityLinks.map((c) => (
              <li key={c.path}>
                <Link to={c.path} className="hover:text-white transition-colors">Chauffeur {c.name}</Link>
              </li>
            ))}
            <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li><Link to="/terms" className="hover:text-white transition-colors">Terms & Conditions</Link></li>
          </ul>
        </div>

        <div className="col-span-2">
          <h4 className="font-semibold mb-4 text-amber-400">Popular Areas We Service</h4>
          <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-gray-400">
            {locations.map((l) => (
              <Link key={l.slug} to={`/limo-hire/${l.slug}`} className="hover:text-white transition-colors">
                {l.name} transfers
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 pt-6 text-center">
        <p className="text-gray-500 text-xs max-w-4xl mx-auto mb-4">
          Limo near me · airport transfers Brisbane · airport transfers Gold Coast · chauffeur Sydney ·
          chauffeur Melbourne · minibus charter with driver · Mercedes Sprinter hire · wedding transport ·
          cruise terminal transfers · corporate cars · limo hire near me — servicing all of South East Queensland and beyond, 24/7.
        </p>
        <p className="text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} Limo Near Me. All rights reserved. ABN 22 680 932 003
        </p>
      </div>
    </div>
  </footer>
  </>
);

export default SeoFooter;
